import styled from "styled-components";
import { GeneralSegment } from "styles";

export const ResultListSegment = styled(GeneralSegment)`
  margin-bottom: 16px;
`;
